/**
 * Created by dushyantha on 9/15/16.
 */
 (function () {
    'use strict';

    /**
     * @ngdoc service
     * @name profile.service:ProfileService
     *
     * @description
     *
     */
    angular
        .module('crewProfile')
        .service('ProfileService', ProfileService);
        function ProfileService(RemoteService,crewProfileDTOFactory,profileAdaptorFactory) {
            var vm = this;



            /**
             * Search Crew Profile
             * @param param
             * @param successFn
             * @param errorFn
             */
            vm.searchCrewProfile= function(param,successFn, errorFn) {

                RemoteService.searchCrewProfile(param.crewID, true).then(
                    function (response) {
                        successFn(adaptCrewSearchDto(response.crewSearchDto));
                    },
                    function (error) {
                        errorFn(error.msg[0]);
                    }
                );

            };

            /**
             * Search Crew Language Skills
             * @param param
             * @param successFn
             * @param errorFn
             */
            vm.searchCrewLanguageSkills= function(param,successFn, errorFn) {

                RemoteService.getLanguageSkillsData(param, true).then(
                    function (response) {
                        successFn(response.language);
                    },
                    function (error) {
                        errorFn(error.msg[0]);
                    }
                );

            };

            /**
             * GET ALV Groups
             * @param successFn
             * @param errorFn
             */
            vm.getAlvGroups= function(crewType, successFn, errorFn) {

              RemoteService.getAlvGroups(crewType).then(
                function (response) {
                  successFn(response);
                },
                function (error) {
                  errorFn(error.msg[0]);
                }
              );

            };

            /**
             * Search Trainer types
             * @param successFn
             * @param errorFn
             */
            vm.getTrainerTypes= function(successFn, errorFn) {

                RemoteService.getTrainerTypes().then(
                    function (response) {
                        successFn(response.trainerTypeList);
                    },
                    function (error) {
                        errorFn(error.msg[0]);
                    }
                );

            };
            /**
             * Edit Save Crew Profile
             * @param crewDto
             * @param successFn
             * @param errorFn
             */
            vm.editSaveCrewProfile = function(crewDto,successFn, errorFn){
                crewDto.status=crewDto.status? "ACT" : "INA";
                var  param = {
                    crewSearchDto:crewDto
                };
                if(!!crewDto.languageCodes){
                  crewDto.languageCodes=adaptLanguageSkills(crewDto.languageCodes);
                }
                RemoteService.editSaveCrewProfile(param, true).then(
                    function (response) {
                        successFn(response);
                    },
                    function (error) {
                        errorFn(error.msg[0]);
                    }
                );
            };

            /**
             * Get crew management positions
             * @param param
             * @param successFn
             * @param errorFn
             */
            vm.getManagementCrewPositions = function(successFn, errorFn){

                RemoteService.managementCrewPositions().then(
                    function (response) {
                        successFn(response.managementCrewPositionList);
                    },
                    function (error) {
                        errorFn(error.msg[0]);
                    }
                );
            };

            /**
             * Get Crew Default validations
             * @param crewProfileId
             * @param successFn
             * @param errorFn
             */
            vm.getCrewDefaultValidation = function (crewProfileId,successFn,errorFn) {
                RemoteService.getCrewDefaultValidation(crewProfileId).then(
                    function (response) {
                        successFn(profileAdaptorFactory.getDefaultValidationsAdaptor(response));
                    },
                    function (error) {
                        errorFn(error)
                    }
                );
            };

            /**
             * Get Crew defailt validations by crew type
             * @param crewTypeCode
             * @param successFn
             * @param errorFn
             */
            vm.getCrewTypeDefaultValidation = function (crewTypeCode,successFn,errorFn) {
                RemoteService.getCrewTypeDefaultValidation(crewTypeCode).then(
                    function (response) {
                        successFn(profileAdaptorFactory.getCrewTypeValidationAdaptor(response));
                    },
                    function (error) {
                        errorFn(error)
                    }
                );
            };

            /**
             * Save Crew Default Validations
             * @param params
             * @param successFn
             * @param errorFn
             */
            vm.saveCrewDefaultValidation = function (params,successFn,errorFn) {
                var request = crewProfileDTOFactory.CrewDefaultValidationDTO();
                request.crewProfileId = params.crewProfileId;
                angular.forEach(params.defaultValidations, function (item) {
                    if('Y' == item.isAssigned){
                        request.defaultValidationIds.push(item.validationId);
                        request.defaultValidationCodes.push(item.validationCode);
                    }
                });
                RemoteService.saveCrewDefaultValidation(request).then(
                    function (response) {
                        successFn(response);
                    },
                    function (error) {
                        errorFn(error)
                    }
                );
            };

            /**
             * Add Delete Language skills
             * @param crewProfileId
             * @param languageSkillDTO
             * @param successFn
             * @param errorFn
             */
            vm.addDeleteExclusion = function (crewProfileId,exclusionDTO,type,successFn, errorFn, confirmed) {
               var param = {};
                param.crewProfId=crewProfileId;
                param.confirmed = confirmed === true;
                if(type === 'language'){
                    param.languageCodes= adaptLanguageSkills(exclusionDTO);
                }
                else{
                  param.airportCodes = adaptAirportExclusion(exclusionDTO.airportExclusion);
                  param.excludedCrewIds = exclusionDTO.crewExclusion;
                }
                RemoteService.editDeleteExclusion(param,true).then(
                    function (response) {
                        successFn(response);
                    },
                    function (error) {
                        errorFn(error.msg[0]);
                    }
                );
            };

            vm.addDeleteInclusion = function (crewProfileId, inclusionDTO, successFn, errorFn, confirmed) {
              var param = {};
              param.crewProfileId = crewProfileId;
              param.includedAirports = adaptAirportInclusion(inclusionDTO.airportInclusion);
              param.confirmed = confirmed === true;
              RemoteService.editDeleteInclusion(param,true).then(
                function (response) {
                  successFn(response);
                },
                function (error) {
                  errorFn(error.msg[0]);
                }
              );
            };

            /**
             * Get crew fleet experience data
             * @param crewProfileId
             * @param successFn
             * @param errorFn
             */
            vm.getFleetExperience = function (crewProfileId,successFn, errorFn) {
                var param = {};
                param.crewProfileId=crewProfileId;

                RemoteService.getFleetExperience(param).then(
                    function (response) {
                        successFn(response.fleetExperienceCollection);
                    },
                    function (error) {
                        errorFn(error.msg[0]);
                    }
                );
            };

            vm.addEditFleetExperience =function (param,successFn, errorFn) {


                RemoteService.addEditFleetExperience(param,true).then(
                    function (response) {
                        successFn(response);
                    },
                    function (error) {
                        errorFn(error.msg[0]);
                    }
                );
            };

            vm.addEditCrewBase =function (param,successFn, errorFn) {
                RemoteService.addEditCrewBase(param,true).then(
                    function (response) {
                        successFn(response);
                    },
                    function (error) {
                        errorFn(error.msg[0]);
                    }
                );
            };

            vm.addEditCrewSecondaryBase =function (param,successFn, errorFn) {
                RemoteService.addEditCrewSecondaryBase(param,true).then(
                    function (response) {
                        successFn(response);
                    },
                    function (error) {
                        errorFn(error.msg[0]);
                    }
                );
            };

            vm.deleteCrewBaseService =function (param,successFn, errorFn) {
                RemoteService.deleteCrewBaseRemote(param,true).then(
                    function (response) {
                        successFn(response);
                    },
                    function (error) {
                        errorFn(error.msg[0]);
                    }
                );
            };

            vm.deleteCrewSecondaryBaseService =function (param,successFn, errorFn) {
                RemoteService.deleteSecondaryCrewBaseRemote(param,true).then(
                    function (response) {
                        successFn(response);
                    },
                    function (error) {
                        errorFn(error.msg[0]);
                    }
                );
            };

          vm.deleteDateRangeService =function (param,successFn, errorFn) {
            RemoteService.deletePositionDateRange(param,true).then(
              function (response) {
                successFn(response);
              },
              function (error) {
                errorFn(error.msg[0]);
              }
            );
          };

          vm.addEditPositionDateRange =function (param,successFn, errorFn) {
            RemoteService.addEditPositionDateRange(param,true).then(
              function (response) {
                successFn(response);
              },
              function (error) {
                errorFn(error.msg[0]);
              }
            );
          };

            /**
            * Get crew payment details
            * @param crewProfileId
            * @param successFn
            * @param errorFn
            */
            vm.getCrewPaymentDetails = function (crewProfileId,successFn, errorFn) {

                RemoteService.getCrewPaymentDetails(crewProfileId).then(
                    function (response) {
                        successFn(response.paymentRateDTO);
                    },
                    function (error) {
                        errorFn(error.msg[0]);
                    }
                );
            };

            /**
             * Get crew payment Range details
             * @param crewProfileId
             * @param successFn
             * @param errorFn
             */
            vm.getCrewPaymentRangeDetails = function (crewProfileId, successFn, errorFn) {

                RemoteService.getCrewPaymentRangeDetails(crewProfileId).then(
                    function (response) {
                        successFn(response);
                    },
                    function (error) {
                        errorFn(error);
                    }
                );
            };

            /**
             * Get crew other payment details
             * @param crewProfileId
             * @param successFn
             * @param errorFn
             */
            vm.getCrewOtherPaymentDetails = function (crewProfileId, successFn, errorFn) {

                RemoteService.getCrewOtherPaymentDetails(crewProfileId).then(
                    function (response) {
                        successFn(response);
                    },
                    function (error) {
                        errorFn(error);
                    }
                );
            };

            /**
             * Save Crew Payment Range Details
             * @param crewProfileId
             * @param successFn
             * @param errorFn
             */
            vm.saveCrewPaymentRangeDetails = function (param, successFn, errorFn) {

                RemoteService.saveCrewPaymentRangeDetails(param).then(
                    function (response) {
                        successFn(response);
                    },
                    function (error) {
                        errorFn(error);
                    }
                );
            };

            /**
             * Save Other Payment Rates
             * @param crewProfileId
             * @param successFn
             * @param errorFn
             */
            vm.saveCrewOtherPaymentRates = function (param, successFn, errorFn) {

                RemoteService.saveCrewOtherPaymentRates(param).then(
                    function (response) {
                        successFn(response);
                    },
                    function (error) {
                        errorFn(error);
                    }
                );
            };//

            /**
             * Delete Payment FLy hour Range Rates
             * @param crewProfileId
             * @param successFn
             * @param errorFn
             */
            vm.deleteCrewFlyingHourRates = function (param, successFn, errorFn) {

                RemoteService.deleteCrewPaymentRangeDetail(param).then(
                    function (response) {
                        successFn(response);
                    },
                    function (error) {
                        errorFn(error);
                    }
                );
            };
            /**
             * Update payment rate details
             * @param param
             * @param successFn
             * @param errorFn
             */
            vm.updatePaymentInfo =function(param,successFn, errorFn){
                RemoteService.updatePaymentInfo(param).then(
                    function (response) {
                        successFn(response);
                    },
                    function (error) {
                        errorFn(error.msg[0]);
                    }
                );
            };

            vm.getCrewUpgradeData = function(param,successFn,errorFn){
                RemoteService.crewUpgradeData(param).then(
                    function (response) {
                        successFn(response.crewUpgradeList)
                    },
                    function (error) {
                        errorFn(error.mgg)
                    }
                );
            };

            vm.getCrewTrainingStages = function(param,successFn,errorFn){
              RemoteService.getCrewTrainingStages(param).then(
                function (response) {
                  successFn(response.crewTypeStageResponseDTOS)
                },
                function (error) {
                  errorFn(error.msg[0])
                }
              );
            };

            vm.updateTrainingStageStatus = function (param, successFn, errorFn) {
              RemoteService.updateTrainingStageStatus(param).then(
                function (response) {
                  successFn(response);
                },
                function (error) {
                  errorFn(error.msg[0]);
                }
              );
            };

            vm.getCrewBaseAssignmentData = function(param,successFn,errorFn){
                RemoteService.getCrewBaseAssignment(param).then(
                    function (response) {
                        successFn(response.crewBaseAssignmentCollection)
                    },
                    function (error) {
                        errorFn(error.mgg)
                    }
                );
            };

            vm.getEffectedBaseList=function(param,successFn,errorFn){
              RemoteService.getEffectedBaseList(param).then(
                function (response) {
                  successFn(response)
                },
                function (error) {
                  errorFn(error.mgg)
                }
              );
            };

            vm.getAllCrewBaseAssignmentData = function(param,successFn,errorFn){
                RemoteService.getAllCrewBaseAssignment(param).then(
                    function (response) {
                        successFn(response.crewBaseAssignmentHistoryDTOs)
                    },
                    function (error) {
                        errorFn(error.mgg)
                    }
                );
            };

            vm.getAllCrewLayoverAccommodationPreferences = function(param,successFn,errorFn){
                RemoteService.getAllCrewLayoverAccommodationPreferences(param.crewProfileId).then(
                    function (response) {
                        successFn(response.crewLayoverAccommodationPreferenceDTOList)
                    },
                    function (error) {
                        errorFn(error.mgg)
                    }
                );
            };

          vm.getCrewAcmiRangesForEdit = function(param,successFn,errorFn){
            RemoteService.getCrewACMIData(param).then(
              function (response) {
                successFn(response.crewACMIRangeDTOList)
              },
              function (error) {
                errorFn(error.mgg)
              }
            );
          };

          vm.getCrewAcmiHistoryData = function(param,successFn,errorFn){
            RemoteService.getCrewACMIHistory(param).then(
              function (response) {
                successFn(response.crewACMIRangeDTOList)
              },
              function (error) {
                errorFn(error.mgg)
              }
            );
          };

            vm.addEditTrainingStage = function (param,successFn, errorFn) {
              RemoteService.addEditTrainingStage(param,true).then(
                function (response) {
                  successFn(response);
                },
                function (error) {
                  errorFn(error.msg[0]);
                }
              );

            };

            vm.addEditCrewUpgrade= function (param,successFn, errorFn) {

                RemoteService.addEditCrewUpgradeData(param,true).then(
                    function (response) {
                        successFn(response);
                    },
                    function (error) {
                        errorFn(error.msg[0]);
                    }
                );

            };

            vm.deleteCrewUpgrade= function (param,successFn, errorFn) {

                RemoteService.deleteCrewUpgradeData(param).then(
                    function (response) {
                        successFn(response);
                    },
                    function (error) {
                        errorFn(error.msg[0]);
                    }
                );

            };

            vm.searchCrewExclusion= function(param,successFn, errorFn){
                RemoteService.searchCrewExclusion(param).then(
                    function (response) {
                        successFn(response.crewExclusionCollection);
                    },
                    function (error) {
                        errorFn(error.msg[0]);
                    }
                );
            };
            vm.searchAirportExclusion =function(param,successFn, errorFn){
                RemoteService.searchAirportExclusion(param).then(
                    function (response) {
                        successFn(response.airportExclusions);
                    },
                    function (error) {
                        errorFn(error.msg[0]);
                    }
                );
            };
            vm.searchAirportInclusion =function(param,successFn, errorFn){
              RemoteService.searchAirportInclusion(param).then(
                function (response) {
                  successFn(response.airportInclusions);
                },
                function (error) {
                  errorFn(error.msg[0]);
                }
              );
            };
            vm.searchOtherHubData = function (param,successFn, errorFn) {
                RemoteService.searchHoursData(param,true).then(
                    function (response) {
                        successFn(adaptOtherHubData(response.hoursDataCollection));
                    },
                    function (error) {
                        errorFn(error.msg[0]);
                    }
                );
            };

            vm.searchTotalOtherHubData = function (param,successFn, errorFn) {
                RemoteService.searchTotalOtherHubData(param,true).then(
                    function (response) {
                        successFn(adaptTotalOtherHubData(response.groupTotalHoursDataAdaptDTOCollection));
                    },
                    function (error) {
                        errorFn(error.msg[0]);
                    }
                );
            };
            vm.saveHoursData = function (param,successFn, errorFn) {
                RemoteService.saveHoursData(param,true).then(
                    function (response) {
                        successFn(response);
                    },
                    function (error) {
                        errorFn(error.msg[0]);
                    }
                );
            };

            vm.savePreferenceData = function (param,successFn, errorFn) {
                RemoteService.savePreferenceData(param,true).then(
                    function (response) {
                        successFn(response);
                    },
                    function (error) {
                        errorFn(error.msg[0]);
                    }
                );
            };

            vm.importHoursData = function (param, successFn, errorFn) {
                RemoteService.importHoursData(param, true).then(
                    function (response) {
                        successFn(response);
                    },
                    function (error) {
                        errorFn(error.msg[0]);
                    }
                );
            };

            vm.deleteHoursData = function (param,successFn, errorFn) {
                RemoteService.deleteHoursData(param,true).then(
                    function (response) {
                        successFn(response);
                    },
                    function (error) {
                        errorFn(error.msg[0]);
                    }
                );
            };

            vm.deletePreferenceData = function (param,successFn, errorFn) {
                RemoteService.deletePreferenceData(param,true).then(
                    function (response) {
                        successFn(response);
                    },
                    function (error) {
                        errorFn(error.msg[0]);
                    }
                );
            };

            vm.getHubDetails = function (successFn, errorFn) {

                RemoteService.getHubDetails().then(
                    function (response) {
                        successFn(response);
                    },
                    function (error) {
                        errorFn(error.msg[0]);
                    }
                );
            };
            vm.getHubs = function (successFn, errorFn) {

                RemoteService.getHubs().then(
                    function (response) {
                        successFn(response);
                    },
                    function (error) {
                        errorFn(error.msg[0]);
                    }
                );
            };
            vm.getAutoImportAllowedClients = function (successFn, errorFn) {
                RemoteService.getAutoImportAllowedClients().then(
                    function (response) {
                        successFn(response);
                    },
                    function (error) {
                        errorFn(error.msg[0]);
                    }
                );
            };

            vm.convertToMinutes= function (time) {
                var adaptTime='';
                if(time.toString().indexOf(':') > -1){
                    var temp = time.split(':');
                    adaptTime =(parseInt(temp[0])*60)+parseInt(temp[1]);
                }
                else{
                    adaptTime = time;
                }
                return adaptTime;
            };
            function convertMinutesToHours(minutes) {
                var H = Math.floor(minutes / 60);
                var M = minutes % 60;
                if (M < 10) {
                    M = '0' + M;
                }
                return H + ':' + M;
            }
            function adaptOtherHubData(otherHubHours){
                angular.forEach(otherHubHours, function(value) {
                   value.flyingHoursInHHMI = convertMinutesToHours(value.flyingHoursInMins);
                   value.dutyHoursInHHMI = convertMinutesToHours(value.dutyHoursInMins);
                   value.isSelected = false;
                });
                return otherHubHours
            }
            function adaptTotalOtherHubData(totalOtherHubHours){
                angular.forEach(totalOtherHubHours, function(value) {
                   value.totalFlyingHoursInHHMI = convertMinutesToHours(value.totalFlyingHoursInMins);
                   value.totalDutyHoursInHHMI = convertMinutesToHours(value.totalDutyHoursInMins);
                });
                return totalOtherHubHours
            }

            function adaptManagementPosition(mgtPos){
              angular.forEach(mgtPos, function(value) {

              });
              return adaptedManagementPos;
            }

            function adaptCrewSearchDto(crewSearchDto){

                crewSearchDto.passwordInfo = null;
                crewSearchDto.status = (crewSearchDto.status === 'ACT')?true:false;
                return crewSearchDto;
            }


          function adaptLanguageSkills(languages) {
            var skills = [];
            angular.forEach(languages,function (lang) {

              var skill = new crewProfileDTOFactory.createLanguageSkillDTO();
              skill.status = lang.status === null? 'ACT':lang.status;
              skill.languageCode = lang.languageCode;
              skill.effectiveFromDate = lang.effectiveFromDate;
              skill.languageSkillId = lang.languageSkillId;
              skills.push(skill);

            })

            return skills;
          }

            function adaptAirportExclusion(param) {
                var codes=[];
                angular.forEach(param, function(value, key) {

                        codes.push(value);
                });

                return codes;
            }
            function adaptAirportInclusion(param) {
              var airportCodes=[];
              angular.forEach(param, function(value, key) {
                airportCodes.push(value);
              });
              return airportCodes;
            }

            function adaptCrew(param){
                var codes=[];
                angular.forEach(param, function(value) {
                    angular.forEach(value.crewExclusion, function(crew) {
                         codes.push(crew.excludedCrewProfileId);
                    });
                });
                return codes;
            }

          vm.addCrewACMIRange =function (param,successFn, errorFn) {
            RemoteService.addCrewACMIRange(param,true).then(
              function (response) {
                successFn(response);
              },
              function (error) {
                errorFn(error.msg[0]);
              }
            );
          };

          vm.saveEditACMIRanges = function (params,successFn,errorFn) {
            var request = crewProfileDTOFactory.editSaveACMIRangesRequestDTO();
            request.crewProfileId = params.crewProfileId;
            request.editedAcmiRanges = params.editedAcmiRanges;
            RemoteService.editCrewACMIRanges(request).then(
              function (response) {
                successFn(response);
              },
              function (error) {
                errorFn(error)
              }
            );
          };

          vm.onACMIRangeDelete = function (params,successFn,errorFn) {
            var request = crewProfileDTOFactory.deleteACMIRangesRequestDTO();
            request.crewProfileId = params.crewProfileId;
            request.acmiRangeId = params.rangeId;
            RemoteService.deleteCrewACMIRange(request).then(
              function (response) {
                successFn(response);
              },
              function (error) {
                errorFn(error)
              }
            );
          };


          vm.getCrewAirportRecencyData = function(param,successFn,errorFn){
            RemoteService.getCrewAirportRecencyData(param.crewProfileId).then(
              function (response) {
                successFn(response)
              },
              function (error) {
                errorFn(error)
              }
            );
          };

          vm.getCrewLayoverAccommodationPreferences = function(param,successFn,errorFn){
            RemoteService.getCrewLayoverAccommodationPreferences(param.crewProfileId).then(
              function (response) {
                successFn(response)
              },
              function (error) {
                errorFn(error)
              }
            );
          };





          vm.getAssignedBatchesForCrew = function (crewProfileId, successFn, errorFn) {
              var param = { crewProfileIds: [crewProfileId] };
              RemoteService.getAssignedBatchesForCrew(param, true).then(
                  function (response) {
                      successFn(response.batchList || []);
                  },
                  function (error) {
                      errorFn(error.msg ? error.msg[0] : error);
                  }
              );
          };


          vm.assignCrewToBatch = function (crewProfileId, crewBatchCode, successFn, errorFn) {
              var param = {
                  targetBatchCode: crewBatchCode,
                  crewProfileIds: [crewProfileId]
              };
              RemoteService.assignCrewToBatchFromProfile(param, true).then(
                  function (response) {
                      successFn(response);
                  },
                  function (error) {
                      errorFn(error.msg ? error.msg[0] : error);
                  }
              );
          };


          vm.removeCrewFromBatch = function (crewProfileId, crewBatchCode, successFn, errorFn) {
              var param = {
                  targetBatchCode: crewBatchCode,
                  crewProfileIds: [crewProfileId]
              };
              RemoteService.removeCrewFromBatchFromProfile(param, true).then(
                  function (response) {
                      successFn(response);
                  },
                  function (error) {
                      errorFn(error.msg ? error.msg[0] : error);
                  }
              );
          };
        }
}());
